import React from 'react';
import classNames from 'classnames/bind';

import { useTranslation } from 'react-i18next';

import UserAvatar from 'components/UserAvatar';

import styles from './MiniUserDetail.module.scss';

const cx = classNames.bind(styles);

interface MiniUserDetailProps {
  userId: string;
  username: string;
  avatar: string;
}

const MiniUserDetail: React.FC<MiniUserDetailProps> = ({
  userId,
  username,
  avatar,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx('mini-user-detail')}>
      <UserAvatar
        avatarUrl={avatar}
        className={cx('mini-user-detail__avatar')}
        size="xs"
        userId={userId}
        username={username}
      />
      <div className={cx('mini-user-detail__label')}>
        <div className={cx('mini-user-detail__name')}>{username}</div>
        <div className={cx('mini-user-detail__role')}>
          {t('common-student', 'Student')}
        </div>
      </div>
    </div>
  );
};

export default MiniUserDetail;
